const namespace = 'AUTHENTICATION_';

export default {
  REQUEST_LOGIN: `${namespace}REQUEST_LOGIN`,
  REQUEST_SIGNUP: `${namespace}REQUEST_SIGNUP`
};
